// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cbZU","name":"styles_name__1TQ69","phone":"styles_phone__1UteS"};